export enum Status {
  STAKED = "STAKED",
  SPENT = "SPENT",
  UNSPENT = "UNSPENT",
  EXPORT = "EXPORT",
}

export interface FundsHistory {
  Amount: number;
  Status: Status;
  TxID: string;
  Timestamp: number;
}
